import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// تكوين الترجمات
const resources = {
  ar: {
    translation: {
      // واجهة تسجيل الدخول
      'login.title': 'تسجيل الدخول',
      'login.prompt': 'الرجاء إدخال الرمز للوصول:',
      'login.button': 'دخول',
      'login.error': 'رمز الدخول غير صحيح. الرجاء المحاولة مرة أخرى.',
      
      // واجهة الدردشة
      'chat.welcome': 'مرحباً! كيف يمكنني مساعدتك اليوم؟',
      'chat.placeholder': 'اكتب رسالتك هنا...',
      'chat.send': 'إرسال',
      'chat.upload': 'رفع ملف PDF',
      
      // الإعدادات
      'settings.title': 'الإعدادات',
      'settings.language': 'اللغة',
      'settings.theme': 'المظهر',
      'settings.save': 'حفظ',
      
      // عام
      'app.name': 'مُهَيَّم',
      'app.footer': 'مدعوم بواسطة MHEM AI',
      'app.loading': 'جاري التحميل...',
      'app.error': 'حدث خطأ. الرجاء المحاولة مرة أخرى.',
    }
  },
  en: {
    translation: {
      // Login Interface
      'login.title': 'Login',
      'login.prompt': 'Please enter the access code:',
      'login.button': 'Enter',
      'login.error': 'Incorrect access code. Please try again.',
      
      // Chat Interface
      'chat.welcome': 'Hello! How can I help you today?',
      'chat.placeholder': 'Type your message here...',
      'chat.send': 'Send',
      'chat.upload': 'Upload PDF',
      
      // Settings
      'settings.title': 'Settings',
      'settings.language': 'Language',
      'settings.theme': 'Theme',
      'settings.save': 'Save',
      
      // General
      'app.name': 'MHEM',
      'app.footer': 'Powered by MHEM AI',
      'app.loading': 'Loading...',
      'app.error': 'An error occurred. Please try again.',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // اللغة الافتراضية هي العربية
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // لا داعي للهروب من HTML
    }
  });

export default i18n;
